var default_port = [4321,4322,4323];


export var hub = (function(){
	//private
	var callBuilder = function(module){

		// var module = module;
		var val = {};
		var p = default_port;
		var failHandler = function () {

        }
		return {
			param: function(key,attr){
				val[key] = attr;
				return this;
			},
			value: function(value){
				console.log(value);
				val = value;
				return this;
			},
			port: function(prt){
				p = prt;
				return this;
			},
			onFail: function (fail) {
				failHandler = fail;
				return this;
            },
			call: function(handler){
				callWebSocket(handler,module,val,p,0,failHandler,false);
			}

		};
	}

	var callWebSocket = function(handler,module,value,port,i,failHandler,tryOnce){
		console.log("wss://127.0.0.1:" + port[i]);
		console.log(value);
		var ws = new WebSocket("wss://127.0.0.1:" + port[i]);

		ws.onopen = function(){
			//var msg = JSON.stringify({'module':module,'value':JSON.stringify(value)});
			var msg = JSON.stringify({'module':module,'value':value});
			console.log(msg);
			console.log(value)
			ws.send(msg);
		},
		ws.onerror = function(){
			if(i == 2){
				window.open('iscert:/', '_self');
				if(tryOnce)
					failHandler();
				else
					setTimeout(function(){callWebSocket(handler,module,value,port,(i+1)%3,failHandler,true)},5000);
				return;
			}
			callWebSocket(handler,module,value,port,(i+1)%3,failHandler,tryOnce);
		},
		ws.onmessage = function(r){
			handler(JSON.parse(r.data));
		}

	}
	//public
	return {
		/**
		*	Lanza el iSCert, si esta no se encuentra ya levantado
		*	NOTA: En general el hub se levanta solo y no es necesario
		*	llamar a este metodo explicitamente,
		*/
		launch: function(){
			window.open('iscert:/', '_self');
		},

		/**
		*	Devuelve un builder que permite contruir la consulta,
		*	consta de las siguientes operaciones, cada una de las cuales devuelve
		*   el builder para seguir operando, a menos de los metodos terminales:
		*	+ param(key,attr), agrega un nuevo atributo 'attr' al value, con nombre 'key'.
		*	+ port(prt) setea prt como puerto para la conexion con el websocket (opcional, por defecto 4321).
		*	+ call(handler) operacion terminal, que permite
		*
		*/
		caller: function(module){
			return new callBuilder(module);
		},
		/**
		*	Llama al hub con los parametros asociados.
		*/
		call: function(module,value,handler,port){
			var c = this.caller(module).value(value);
			port = port || default_port;
			c.port(port);
			c.call(handler);
		}

	};
})()
